import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router";
import {
  GLOBAL_SETTING,
  GLOBAL_FINANCE,
  EDIT_LETTERHEAD,
  EDIT_TEMPLATES,
  PROJECT_CATEGORIES,
  WORK_HOUR_SETTINGS,
  FEATURE_FLAGS,
  ACCOUNTING_INTEGRATION,
} from "../../constants/route-paths";
import Finance from "./finance";
import LetterHead from "./letterhead";
import EditTemplates from "./edit-templates";
import ProjectCategories from "./project_categories";
import WorkHourSettingsPage from "../work-hour-settings/work-hour-settings-page";
import FeatureFlagsPage from "./feature-flags";
import AccountingSettings from "./accounting";
import "./scss/templates.scss";
import { withRouter } from "../../util/with-router";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCard: "LETTERHEAD",
    };
    this.child = React.createRef();
  }

  componentDidMount() {
    const urlPath = window.location.pathname;
    let selectedCard = "";
    if (urlPath === `/${GLOBAL_SETTING}/${EDIT_LETTERHEAD}`) {
      selectedCard = "LETTERHEAD";
    } else if (urlPath === `/${GLOBAL_SETTING}/${GLOBAL_FINANCE}`) {
      selectedCard = "FINANCE";
    } else if (urlPath === `/${GLOBAL_SETTING}/${EDIT_TEMPLATES}`) {
      selectedCard = "TEMPLATES";
    } else if (urlPath === `/${GLOBAL_SETTING}/${PROJECT_CATEGORIES}`) {
      selectedCard = "PROJECT";
    } else if (urlPath.startsWith(`/${GLOBAL_SETTING}/${WORK_HOUR_SETTINGS}`)) {
      selectedCard = "WORK_HOUR";
    } else if (urlPath === `/${GLOBAL_SETTING}/${FEATURE_FLAGS}`) {
      selectedCard = "FEATURE_FLAGS";
    } else if (urlPath === `/${GLOBAL_SETTING}/${ACCOUNTING_INTEGRATION}`) {
      selectedCard = "ACCOUNTING";
    }
    if (selectedCard) this.setState({ selectedCard });
  }

  handleCardClick = (selectedCard = "LETTERHEAD") => {
    this.setState({ selectedCard }, () => {
      if (selectedCard === "LETTERHEAD") {
        this.props.history(`/${GLOBAL_SETTING}/${EDIT_LETTERHEAD}`);
      } else if (selectedCard === "FINANCE") {
        this.props.history(`/${GLOBAL_SETTING}/${GLOBAL_FINANCE}`);
      } else if (selectedCard === "TEMPLATES") {
        this.props.history(`/${GLOBAL_SETTING}/${EDIT_TEMPLATES}`);
      } else if (selectedCard === "PROJECT") {
        this.props.history(`/${GLOBAL_SETTING}/${PROJECT_CATEGORIES}`);
      } else if (selectedCard === "WORK_HOUR") {
        this.props.history(`/${GLOBAL_SETTING}/${WORK_HOUR_SETTINGS}`);
      } else if (selectedCard === "FEATURE_FLAGS") {
        this.props.history(`/${GLOBAL_SETTING}/${FEATURE_FLAGS}`);
      } else if (selectedCard === "ACCOUNTING") {
        this.props.history(`/${GLOBAL_SETTING}/${ACCOUNTING_INTEGRATION}`);
      }
    });
  };
  addProjectType = () => {
    if (this.child && this.child.current) this.child.current.handleAddDialog();
  };
  render() {
    const { selectedCard } = this.state;
    return (
      <>
        <div className="purchase-order-block">
          {/* <div className="row">
            <div className="w-auto">
              <h2 className="content-heading text-uppercase">Global Setting</h2>
            </div> */}

          {/* {selectedCard === "PROJECT" && writePermission && (<div className="w-auto ms-auto mt-auto">
              <button onClick={this.addProjectType} className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary">
                Add Project Type
              </button>
            </div>)} */}
          {/* </div> */}

          <div className="row">
            <div className="col-12">
              <Tabs
                defaultActiveKey="LETTERHEAD"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={(k) => { this.handleCardClick(k) }}
                activeKey={selectedCard}
              >
                <Tab eventKey="LETTERHEAD" title={`Company Setting`}></Tab>
                <Tab eventKey="FINANCE" title={`Finance and Tax`}></Tab>
                <Tab eventKey="TEMPLATES" title={`Template Setting`}></Tab>
                <Tab eventKey="PROJECT" title={`Project Categories`}></Tab>
                <Tab eventKey="WORK_HOUR" title={`Work Hour Settings`}></Tab>
                {this.props.user.global_user && (
                  <Tab eventKey="FEATURE_FLAGS" title={`Feature Flags`}></Tab>
                )}
                {(this.props.entitlements?.accountingIntegration ?? true) && (
                  <Tab eventKey="ACCOUNTING" title={`Accounting Integrations`}></Tab>
                )}
              </Tabs>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <Routes>
            <Route path={EDIT_LETTERHEAD} element={<LetterHead {...this.props} />} />
            <Route path={""} element={<LetterHead {...this.props} />} />
            <Route path={GLOBAL_FINANCE} element={<Finance {...this.props} />} />
            <Route path={EDIT_TEMPLATES} element={<EditTemplates {...this.props} />} />
            <Route path={PROJECT_CATEGORIES} element={<ProjectCategories {...this.props} ref={this.child} />} />
            <Route path={WORK_HOUR_SETTINGS} element={<WorkHourSettingsPage {...this.props} />} />
            <Route path={FEATURE_FLAGS} element={<FeatureFlagsPage {...this.props} />} />
            {(this.props.entitlements?.accountingIntegration ?? true) && (
              <Route path={ACCOUNTING_INTEGRATION} element={<AccountingSettings {...this.props} />} />
            )}
          </Routes>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.userData,
  entitlements: state.user.entitlements,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Overview)
);
